import styled from "styled-components"

export const FAQItemsWrapper = styled.div`
  margin: 1rem 0 7.5rem;

  ${({ theme }) => theme.breakpoints.smallDesktop} {
    margin: 2rem 0 10rem;
  }
`
